<template>
  <div class="container-fluid">
    <el-upload
      class="upload mt-5"
      drag
      name="UploadedFile"
      :action="uploadApi"
      :headers="uploadHeaders"
      :file-list="fileList"
      :on-error="uploadError"
      :before-upload="beforeUpload"
      :on-success="getUploadLogs"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Přesuňte soubor nebo
        klikněte zde
        <em>pro nahrání souboru</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        xlsx soubory
        <br>
        <p style="color: red" v-if="uploadStatusError">
          Nepodařilo se nahrát soubor
        </p>
        <p style="color: red" v-if="uploadExistingError">
          Soubor obsahuje záznamy, které již byly dříve nahrány.
        </p>
      </div>
    </el-upload>

    <div class="pt-4">
      <h3>
        Seznam nahraných souborů
      </h3>

      <el-table
        v-loading="loading"
        stripe
        :data="uploadLogs"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="Uživatel" width="150"></el-table-column>
        <el-table-column label="Čas nahrání" width="230">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">
              {{moment(scope.row.uploadedDateTime).format('DD.MM.YYYY, HH:mm:ss')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Název souboru" prop="originalFileName" width="200"></el-table-column>
        <el-table-column label="Záznamy od" width="150">
          <template slot-scope="scope">
            {{moment(scope.row.minRecordedDate).format('DD.MM.YYYY')}}
          </template>
        </el-table-column>
        <el-table-column label="Záznamy do" width="150">
          <template slot-scope="scope">
            {{moment(scope.row.maxRecordedDate).format('DD.MM.YYYY')}}
          </template>
        </el-table-column>
        <el-table-column label="Počet záznamů" prop="numberOfRecords"></el-table-column>
      </el-table>

      <div class="mt-5 mb-5">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagination.pageSize"
          :current-page.sync="pagination.pageNumber"
          :total="pagination.total"
          @current-change="getUploadLogs"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Upload",
  data() {
    return {
      loading: false,
      fileList: [],
      uploadLogs: [],
      pagination: {
        pageSize: 5,
        pageNumber: 1,
        total: 1
      },
      uploadStatusError: false,
      uploadExistingError: false,
    }
  },
  computed: {
    uploadHeaders() {
      return  {
        'Authorization': 'Bearer ' + this.$store.state.accessToken
      }
    },
    uploadApi() {
      return process.env.VUE_APP_API + 'excellines'
    }
  },
  methods: {
    getUploadLogs() {
      this.loading = true
      this.$store.dispatch('getUploadLogs', this.pagination)
        .then(response => {
          this.uploadLogs = response.data
          this.pagination.total = JSON.parse(response.headers['x-pagination']).totalCount
          this.loading = false
        })
    },
    uploadError(error, file) {
      if (file.status === 'fail') {
        if (error.toString().search('DUPLICATE_DATA') >= 0) {
          this.uploadExistingError = true
        } else {
          this.uploadStatusError = true
        }
      }
    },
    beforeUpload() {
      this.uploadStatusError = false
      this.uploadExistingError = false
    }
  },
  created() {
    this.getUploadLogs()
  }
};
</script>

<style>
.upload {
  width: 500px;
  margin-left: auto;
  margin-right: auto;
}
</style>
